export default __webpack_public_path__ + "static/media/1.f8e56027.png";